import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Chevron Up", /*#__PURE__*/_jsx("path", {
  d: "m14.354 10.327-4.348-4.36-4.36 4.36.707.707 3.652-3.652 3.641 3.651.708-.706z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconChevronUp";
export default Icon;